const map = function (arr, callback) {
  const result = [];
  for (let index = 0; index < arr.length; index++) {
    // This is primarily to check if the item
    // exists in the array,
    if (arr.indexOf(arr[index]) > -1) {
      result[index] = callback(arr[index], index, arr);
    }
  }
  return result;
};

export default map;
